module.exports = __webpack_public_path__ + "img/100.a4101b3e.jpg";